import HeaderComponent from '@/screens/SystemConfigure/Components/HeaderComponent/HeaderComponent'
import './OrderTemplates.style.less'
import { Space, Table } from 'antd'
import { orderBy } from 'lodash'
import { useMutation, useQuery } from 'react-query'
import { deleteTemplate, getOrderTemplates } from '../../template.transform'
import { DataType } from '@/screens/Order/Pages/EditOrder/components/ProductRequirementForm/measurement.column'
import PopUpMenu from '@/screens/SystemConfigure/Components/PopUpMenu/PopUpMenu'
import { isEmptyValue } from '@/utils/common'
import { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'
import ToolbarComponent from '@/screens/SystemConfigure/Components/ToolbarComponent/ToolbarComponent'
import AddOrderTemplatesModal from './AddOrderTemplatesModal/AddOrderTemplatesModal'

function OrderTemplates() {
  const [modalOrderTemplate, setModalOrderTemplate] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [searchText, setsearchText] = useState('')

  const onEdit = (data) => {
    setSelectedItem(data)
    setModalOrderTemplate(true)
  }

  const deleteTemplateMutation = useMutation(async (id: string) => {
    await deleteTemplate(id)
    await refetch()
  })

  const onDelete = async (id) => {
    await deleteTemplateMutation.mutateAsync(id)
  }

  const { data, isLoading, refetch } = useQuery(
    ['GET_ORDER_TEMPLATES', searchText],
    async () => {
      const payload = {
        search: searchText,
      }
      return await getOrderTemplates(payload)
    }
  )

  const columns: ColumnsType<DataType> = [
    {
      title: 'NAME',
      dataIndex: 'name',
      align: 'left',
      key: 'name',
      render: (value) => (!isEmptyValue(value) ? value : <p>-</p>),
    },
    {
      title: 'ACTION',
      key: 'action',
      render: (_, record: any) => (
        <Space size="middle">
          <PopUpMenu
            onEdit={() => {
              onEdit(record)
            }}
            onDelete={() => onDelete(record.id)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div>
      <HeaderComponent title="Order Templates" />
      <ToolbarComponent isSearch={true} onSearch={setsearchText} />
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={orderBy(data, ['created_date'], ['desc'])}
      />
      {modalOrderTemplate && (
        <AddOrderTemplatesModal
          visible={modalOrderTemplate}
          onClose={() => setModalOrderTemplate(false)}
          data={selectedItem}
        />
      )}
    </div>
  )
}

export default OrderTemplates
